// extracted by mini-css-extract-plugin
export default {"container":"LmsList_container__Hg2qm","header":"LmsList_header__Cszyu","heading":"LmsList_heading__q4J+E"};